module.exports = __webpack_public_path__ + "img/bookcircle.3affc0bb.png";